import React from 'react';
import { Link } from 'MWComponents';
import '../less/index.less';
import DOMPurify from 'utils/sanitize';

export default function template() {
    const { page, widget, style, usefullDocsMode, titleTag } = this.props;

    const TitleTag = titleTag || 'h2';

    return (
      widget && widget.data && widget.data.length ?
        <div className="downloads">
        <div className={`documents-component ${page} ${usefullDocsMode ? 'usefull' : ''}`} style={style}>
          <div className={`content ${page}`}>
            <TitleTag className={`documents-component-title`}>
              {widget.data[0].title_ua}
            </TitleTag>
            {widget.data.map((file, index) => {
                const filePath = this.changeFilesUrl(file.file_path_ua);
                const fileLink = file.link_path_ua;
                const text = file.name_ua;
                return (
                  usefullDocsMode ?
                    <div key={index} className="usefull-documents-item">
                      <div className="usefull-documents-item-text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text) }}></div>
                      <a className="usefull-documents-item-btn" href={fileLink ? fileLink : filePath} target="_blank">
                        {this.l10n('DOCS_DOWNLOAD_BLANC')}
                      </a>
                    </div>
                    :
                <div key={index} className="documents-component-item">
                  <Link href={fileLink ? fileLink : filePath} target="_blank">
                    <img src={this.changeFilesUrl(file.image_path)} alt='doc-img'></img>
                    <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text) }}></div>
                  </Link>
                </div>)
              }
            )}
          </div>
        </div>
      </div>
        : ''

    );
}
